import React from 'react';

import { useMutation } from '@tanstack/react-query';

import ImportDocumentService from '../../../services/ImportDocumentService';
import { useUiContext } from '../../../context/UiContext';
import { useImportDocumentStore } from '../../../store';

export default function ImportDocumentButton({ importDocument, refetch }) {
  const { showToast } = useUiContext();

  const importDocumentChanges = useImportDocumentStore(
    (state) => state.importDocumentChanges
  );

  const { mutate: startImport, isPending } = useMutation({
    mutationFn: () =>
      ImportDocumentService.importDocument({
        importDocumentId: importDocument.id,
        changes: importDocumentChanges,
      }),
    onSuccess: () => {
      showToast({
        text: 'Success',
        type: 'success',
      });
      refetch();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  if (importDocument?.status !== 'REVIEW') {
    return null;
  }

  let buttonLabel = '';

  if (
    importDocument?._document?.parseur_mailbox_description === 'NOTE' &&
    !importDocument?._import?.loan_id
  ) {
    buttonLabel = 'Generate Loan';
  } else if (
    importDocument?._document?.parseur_mailbox_description !== 'NOTE' &&
    !!importDocument?._import?.loan_id
  ) {
    buttonLabel = 'Import';
  }

  if (!buttonLabel) {
    return null;
  }

  return (
    <button
      className="btn bg-indigo-500 hover:bg-indigo-600 text-white"
      type="button"
      onClick={startImport}
      disabled={isPending}
    >
      {buttonLabel}
    </button>
  );
}
